import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { IEnvironmentConfig } from '@webpack/extra-webpack-types';
import { ErrorHandlerService } from 'src/app/modules/error-handler/error-handler.service';
import { GoogleAnalyticsLibService } from 'src/app/modules/google-tag-manager/google-tag-manager.service';
import { NotifierService } from 'src/app/modules/notifier/notifier.service';
import { UserService } from './core/user/user.service';

/** The main starting component, containing the top most wrapper and loader.  */
@Component({
    selector: 'ofi-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    title = 'treatment-configuration';
    constructor (
        @Inject('ENV') private _env: IEnvironmentConfig,
        @Inject('ERROR_HANDLER_SERVICE') private _errorHandler: ErrorHandlerService,
        private _router: Router,
        private _userService: UserService,
        private _tagManager: GoogleAnalyticsLibService,
        @Inject('NOTIFICATION_SERVICE') private _service: NotifierService,
        @Inject(ViewContainerRef) private _viewContainerRef
    ) {}

    ngOnInit (): void {
        this._service.setRootViewContainerRef(this._viewContainerRef);
        this._tagManager.emitRouterChanges(this._router);

        this._userService.userObservable.subscribe((userObject) => {
            if (userObject) {
                this._errorHandler.logger.configureContext({
                    user: {
                        email: userObject.User.UserName || undefined,
                        username: userObject.User.Name || undefined,
                        id: userObject.User.UserId || undefined
                    },
                    tags: {
                        ['app']: 'treatment-configuration'
                    }
                });
                this._tagManager.emitVisitor({
                    visitor_group: {
                        id: userObject.User.Practices[0] ? userObject.User.Practices[0].PracticeId : undefined,
                        name: userObject.User.Practices[0] ? userObject.User.Practices[0].PracticeName : undefined
                    },
                    visitor_details: {
                        id: userObject.User.UserId,
                        name: userObject.User.Name,
                        role: userObject.User.Roles[0],
                        email: userObject.User.UserName
                    }
                });
            }
        });
    }
}
